import React, { FC, useRef } from 'react';
import { styled } from 'linaria/react';
import { PickDenominationCategory } from '@features/denomination/pick-category';
import { DenominationAmountByServiceIdType, DenominationCategoryType, getActiveDenominations, getDenominationCategories } from '@entities/denomination';
import { checkIsGameWithRegions, useCyberStore, TspPageDenomination, TspPagePayee } from '@entities/tsp';
import { withTheme } from '@shared/lib/theme';
import { useElementRectById } from '@shared/lib';
import { Text } from '@shared/ui/atoms';
import DenominationList from './DenominationList';
interface GameDenominationListWithCategoryPickerProps {
  payee: TspPagePayee;
  denominations: Record<string, TspPageDenomination[]>;
  pricesByServiceId: DenominationAmountByServiceIdType;
}
const GameDenominationListWithCategoryPicker: FC<GameDenominationListWithCategoryPickerProps> = ({
  payee,
  denominations,
  pricesByServiceId
}) => {
  const denominationsByCategoryRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const headerRect = useElementRectById('header');
  const categoryPickerRect = useElementRectById('category-picker');
  const {
    activeCountry
  } = useCyberStore();
  const handleCategoryClick = (category: DenominationCategoryType) => {
    const element = denominationsByCategoryRefs.current[category.label];
    const offset = (headerRect?.height as number || 0) + (categoryPickerRect?.height as number || 0);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;
      setTimeout(() => {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }, 0);
    }
  };
  const isGameWithRegions = checkIsGameWithRegions(payee, denominations);
  const activeDenominations = getActiveDenominations(denominations, activeCountry, isGameWithRegions);
  const categories = getDenominationCategories(activeDenominations);

  // const categories = [
  //   { label: 'asdasd', icon: '' },
  //   { label: '1wertwer', icon: '' },
  //   { label: 'asdafghdfghsd', icon: '' },
  // ]

  return <GameDenominationListWithCategoryPickerWrapper>
      <CategoryPickerWrapper id="category-picker">
        <PickDenominationCategory categories={categories} onCategoryClick={handleCategoryClick} />
      </CategoryPickerWrapper>

      <CategoriesWrapper>
        {categories.map(category => <CategoryWrapper key={category.label} ref={el => {
        denominationsByCategoryRefs.current[category.label] = el;
      }}>
            <Text family="MTSCompact" weight="black" size={{
          desktop: 'h5',
          mobile: 'pM'
        }} color="primary">
              {category.label}
            </Text>
            <DenominationList payee={payee} denominations={activeDenominations.filter(denomination => denomination.features?.subcategory === category.label)} pricesByServiceId={pricesByServiceId} />
          </CategoryWrapper>)}
      </CategoriesWrapper>
    </GameDenominationListWithCategoryPickerWrapper>;
};
export default GameDenominationListWithCategoryPicker;
const GameDenominationListWithCategoryPickerWrapper = /*#__PURE__*/styled('div')({
  name: "GameDenominationListWithCategoryPickerWrapper",
  class: "gc39r02",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const CategoryPickerWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "CategoryPickerWrapper",
  class: "c1bldl8w",
  propsAsIs: false,
  vars: {
    "c1bldl8w-0": [_exp()]
  }
}));
const CategoriesWrapper = /*#__PURE__*/styled('div')({
  name: "CategoriesWrapper",
  class: "c4ldlpo",
  propsAsIs: false
});
const CategoryWrapper = /*#__PURE__*/styled('div')({
  name: "CategoryWrapper",
  class: "c1dsusq5",
  propsAsIs: false
});

require("./GameDenominationListWithCategoryPicker.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./GameDenominationListWithCategoryPicker.tsx");